import { api } from '@api'
import type { SetupFilter } from '../filter'
import type { Pagination } from '../index'
import { applyFilters } from '../utils/applyFilters'

export const handleGetMine = async ({
  filters,
  userId,
  pagination,
}: { filters: SetupFilter; userId: string; pagination: Pagination }) => {
  let query = api().from('setup_enriched').select('*').eq('created_by', userId)

  query = applyFilters(query, filters)

  if (pagination.limit !== undefined && pagination.offset !== undefined) {
    query = query.range(pagination.offset, pagination.offset + pagination.limit - 1)
  }

  const { data } = await query
  return data || []
}
